import { FormItem } from 'sections/EditForm';

const exampleData = {
  title_en: '',
  title_it: '',
  desc_en: '',
  desc_it: '',
  search_words_en: '',
  search_words_it: '',
};

const formData: FormItem[] = [
  {
    name: 'title_en',
    value: exampleData.title_en,
    label: 'Title',
    flag: 'en',
  },
  {
    name: 'title_it',
    value: exampleData.title_it,
    flag: 'it',
  },
  {
    name: 'desc_en',
    value: exampleData.desc_en,
    label: 'Description',
    flag: 'en',
    type: 'textbox',
  },
  {
    name: 'desc_it',
    value: exampleData.desc_it,
    flag: 'it',
    type: 'textbox',
  },
  {
    name: 'search_words_en',
    value: exampleData.search_words_en,
    label: 'Search words',
    flag: 'en',
  },
  {
    name: 'search_words_it',
    value: exampleData.search_words_it,
    flag: 'it',
  },
];

export { formData };
